import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer, useCallback, useMemo } from 'react';
// utils
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

// ----------------------------------------------------------------------

const initialState = {
  isInitialized: false,
  isAuthenticated: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return { ...state, isInitialized: true, isAuthenticated, user };
  },
  LOGIN: (state, action) => ({ ...state, isAuthenticated: true, user: action.payload.user }),
  LOGOUT: (state) => ({ ...state, isAuthenticated: false, user: null }),
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

/**
 * Admin sessiyasi. Ro'yxatdan o'tish va parol tiklash yo'q — hisoblar
 * backend seed'i orqali beriladi.
 */
function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => {
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);
        const { data: user } = await axios.get('/auth/me');
        dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: true, user } });
      } else {
        setSession(null);
        dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: false, user: null } });
      }
    } catch (error) {
      setSession(null);
      dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: false, user: null } });
    }
  }, []);

  useEffect(() => {
    initialize();
  }, [initialize]);

  const login = useCallback(async (phone, password) => {
    const { data } = await axios.post('/auth/login', { phone, password });
    setSession(data.accessToken);
    dispatch({ type: 'LOGIN', payload: { user: data.user } });
  }, []);

  const logout = useCallback(async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  }, []);

  const value = useMemo(() => ({ ...state, login, logout }), [state, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export { AuthContext, AuthProvider };
